export const replaceFullWidthNumerals = (s) => {
  return s.replace(/[\uFF10-\uFF19]/g, (m) => {
    return String.fromCharCode(m.charCodeAt() - 0xfee0);
  });
};
